<template>
  <v-container
    fluid
    class="fill-height"
  >
    <demand-date-grid>
      <template v-slot:data-grid>
        <v-container fluid class="pa-0 card-planta">
          <v-row
            v-for="(item) in plantListSorted"
            :key="item.plantaAbate.nrRegistroSif"
            class="ma-0 pa-0 plant-card__row pr-10"
          >
            <v-col
              cols="2"
              class="first-col d-flex flex-column"
            >
              <span class="plant__text">Planta de Abate</span>
              <span class="sif__text">
                SIF {{ item.plantaAbate.nrRegistroSif }}
              </span>
              <span class="city__text pt-4">{{ item.plantaAbate.nmMunicipio }}</span>
            </v-col>
            <v-col
              v-for="(itemData, i) in listaDatas"
              :key="i + itemData.value + item.plantaAbate.nrRegistroSif"
              class=""
            >
              <v-container fluid>
                <v-row
                  align="center"
                  justify="space-between"
                  class="ma-0 d-flex flex-column"
                >
                  <span class="card-col__text">Informe o número de animais</span>
                  <CardEditavelDemanda
                    v-model="item[itemData.value]"
                    :itemQtAnimals="itemData.value"
                    :cdPlantaAbate="item.plantaAbate.idPlantaAbate"
                    @changeQtAnimalsList="updateQtAnimaisLista"
                    :valueField="item[itemData.value] == 0 ? '0' : item[itemData.value] ? item[itemData.value].toString() : ''"
                    class="mt-6"
                  />
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </demand-date-grid>
    <v-container fluid class="total-float">
      <v-row class="ma-0 pr-10 total-float__row elevation-1">
        <v-col cols="2">
          <span class="total-demand__text">Demanda total</span>
        </v-col>
        <v-col
          v-for="(item, i) in listaDatas"
          :key="i"
          class="pa-0 p-relative"
        >
          <v-divider vertical class="p-absolute" />
          <v-row
            align="center"
            justify="center"
            class="ma-0 pa-3 fill-height"
          >
            <span class="total-demand__value">
              {{ totalDemands[item.value] }}
            </span>
          </v-row>
        </v-col>
        <v-divider vertical />
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex"

import CardEditavelDemanda from "../components/CardEditavelDemanda.vue"
import DemandDateGrid from "@/modules/programacaoAbate/components/DemandTab/DemandDateGrid"

export default {
  name: "Demanda",
  components: {
    DemandDateGrid,
    CardEditavelDemanda,
  },
  data() {
    return {}
  },
  created() {
    this.ActionSetMunicipios(this.municipios)
    this.ActionSetPlantasAbate(this.plantasAbate)
    this.ActionLoadDemands(this.programacaoAbateSelected.idProgramacaoAbate)
  },
  computed: {
    ...mapState(["municipios"]),
    ...mapState(["plantasAbate"]),
    ...mapState("programacaoAbate", [
      "demandSaved",
      "programacaoAbateSelected",
      "listaDatas",
      "listaDemandasPlanta",
      "canEditDemands"
    ]),
    exibeSalvarDemanda() {
      if (!this.demandSaved && this.verifyAllDemandsFilled()) {
        return true
      }
      return false
    },
    exibeAlterarDemanda() {
      if (this.demandSaved && this.verifyAllDemandsFilled()) {
        return true
      }
      return false
    },
    totalDemands() {
      const totalDemands = this.listaDemandasPlanta.reduce((acc, curr) => {
        this.listaDatas.forEach(item => {
          if (!acc) acc = {}
          if (!acc[item.value]) acc[item.value] = parseInt(curr[item.value] || 0)
          else acc[item.value] += parseInt(curr[item.value] || 0)
        })
        return acc
      }, {})
      return totalDemands || {}
    },
    plantListSorted() {
      return this.listaDemandasPlanta.sort((a, b) => a.plantaAbate.idPlantaAbate - b.plantaAbate.idPlantaAbate)
    }
  },
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionInsertProgrammingSlaughter",
      "ActionPreencheAnimaisDemanda",
      "ActionLoadDemands",
      "ActionConfirmarLotes",
      "ActionAlterarDemanda",
      "ActionSetPlantasAbate",
      "ActionSetMunicipios",
      "ActionInserirDemandaBatch",
      "ActionAlterarDemandaBatch",
      "ActionChangeDemandSaved",
      "ActionSetCanEditDemands"
    ]),
    verifyAllDemandsFilled() {
      let preenchidas = true
      this.listaDemandasPlanta.forEach(function (demanda) {
        if (!demanda.demandaPreenchida) {
          preenchidas = false
        }
      })
      return preenchidas
    },
    updateQtAnimaisLista(item) {
      this.ActionPreencheAnimaisDemanda(item)
    },
    salvaDemanda() {
      var context = this
      this.listaDemandasPlanta.forEach(function (demanda) {
        if (demanda.idProgramacaoAbateDemanda) {
          context.ActionAlterarDemanda(demanda)
        } else {
          context.ActionInserirDemanda(demanda)
        }
      })
    },
    alterarDemanda() {
      this.ActionChangeDemandSaved(!this.demandSaved)
    },
  },
}
</script>

<style scoped lang="scss">
.first-col {
  background-color: transparent !important;
  border-top-left-radius: 6px;
  z-index: 1;
}

.plant-card__row {
  margin-bottom: 40px !important;
  background-color: #f2f5f3 !important;
  border: 1px solid #e5e8e7;
  border-radius: 8px;
  opacity: 1;
  
  &.plant-card__row:last-child {
    margin-bottom: 20px !important;
  }
}

.total-float {
  width: 100%;
  left: 0;
  position: sticky;
  bottom: 20px;
  z-index: 99999999;
}

.total-float__row {
  background: white;
  border: 1px solid #f3f3f3;
  border-radius: 5px;
}

.card-col__text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #7B9596;
}

.city__text {
  font: normal normal normal 16px/21px Roboto;
  letter-spacing: 0;
  color: #10303D;
}

.plant__text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #7B9596;
}

.sif__text {
  font: normal normal bold 24px/32px Roboto;
  letter-spacing: 0;
  color: #FF5429;
}

.total-demand__text {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #37565C;
}

.total-demand__value {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #37565C;
}
</style>
